import React from 'react';

export default () => (
  <img
    src="//bat.bing.com/action/0?ti=5063823&Ver=2"
    height="0"
    width="0"
    style={{ display: 'none', visibility: 'hidden' }}
  />
);
